import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const ChoixListe = ({ label, valeur, onChange, options, testId, placeholder }) => (
  <label className="block">
    {label && <span className="at-label block mb-1.5">{label}</span>}
    <Select value={valeur || undefined} onValueChange={onChange}>
      <SelectTrigger className="at-input !bg-[var(--surface-2)] !border-transparent !text-base shadow-none" data-testid={testId}><SelectValue placeholder={placeholder || "Choisir…"} /></SelectTrigger>
      <SelectContent className="at-popover">
        {options.map((o) => <SelectItem key={o.code} value={o.code} className="min-h-[44px] rounded-xl" data-testid={`${testId}-option-${o.code}`}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </label>
);

export function useReferentiels() {
  const [ref, setRef] = useState({ roles: [], partenaires: [] });
  useEffect(() => {
    Promise.all([api.get("/referentiels"), api.get("/partenaires")]).then(([r, p]) =>
      setRef({ roles: r.data.roles, partenaires: p.data.map((s) => ({ code: s.id, label: s.nom })) }));
  }, []);
  return ref;
}
